import palette from '../palette';

export default {
  root: {
    '&.Mui-selected': {
      backgroundColor: palette.background.default,
    },
    '&.MuiTableRow-hover:hover': {
      backgroundColor: palette.background.default,
    },
  },
};
